import React from 'react';
import TextArea from 'shared/components/text-area/TextArea';
import QuestionnaireOptions from './QuestionnaireOptions';

class QuestionnaireForm extends React.Component {
  render() {
    let { kickstartResponce } = this.props;
    let { responses } = kickstartResponce;
    return (
      <div className="questionnaire-form">
        <div className="questions">
          <TextArea
            label= "What are you looking to achieve during your personal training program?"
            value={kickstartResponce && responses ?
              responses['looking-for'] : ''}
            name= ""
            disabled={true}
          />
          <TextArea
            label= "What are you willing to do to achieve your goals?"
            value={kickstartResponce && responses ?
              responses['willing-do'] : ''}
            name= ""
            disabled={true}
          />
          <TextArea
            label= "How will you treat yourself when you achieve your goal?"
            value={kickstartResponce && responses ?
              responses['treat-yourself'] : ''}
            name= ""
            disabled={true}
          />
          <TextArea
            label= "In what time frame would you like to achieve your goal?"
            value={kickstartResponce && responses ?
              responses['timeframe'] : ''}
            name= ""
            disabled={true}
          />
          <TextArea
            label= "How much of a priority is your health and fitness?"
            value={kickstartResponce && responses ?
              responses['health-priority'] : ''}
            name= ""
            disabled={true}
          />
          <TextArea
            label= "How do you feel in your current health state?"
            value={kickstartResponce && responses ?
              responses['health-state'] : ''}
            name= ""
            disabled={true}
          />
          <TextArea
            label= "How would you describe your current diet?"
            value={kickstartResponce && responses ?
              responses['current-diet'] : ''}
            name= ""
            disabled={true}
          />
        </div>

        <QuestionnaireOptions resources={responses && responses.resources ? responses.resources : []} />
      </div>
    );
  }
}

export default QuestionnaireForm;